"use client";

import { ColorOrKey } from "@faire/web--source/slate/Color";
import * as React from "react";
import styled from "styled-components";

import {
  ILinkProps,
  ITextActionProps,
  TextAction,
  onClickTextAction,
} from "./common";

const StyledButton = styled.button`
  ${(props) => (props.disabled ? "cursor: default" : "")};
  display: inline-block;
  width: fit-content;
`;

export interface ITextButtonProps
  extends ILinkProps,
    ITextActionProps,
    React.ButtonHTMLAttributes<HTMLButtonElement> {
  color?: ColorOrKey;
}

/**
 * @deprecated use Button from faire/web/slate/Button with prop variant="tertiary" or EmbeddedLink from faire/web/ui/EmbeddedLink if within a sentence
 * @supersededBy "@faire/web--source/slate/Button/Button#Button"
 * @trackcomponent
 */
export const TertiaryButton: React.FC<ITextButtonProps> = ({
  postEventButtonId,
  onClick,
  icon,
  animate,
  color,
  hoverColor,
  children,
  disabled,
  typographyStyles,
  ...props
}) => (
  <StyledButton
    onClick={onClickTextAction(onClick, postEventButtonId)}
    disabled={disabled}
    {...props}
  >
    <TextAction
      animate={animate}
      color={color}
      hoverColor={hoverColor}
      icon={icon}
      disabled={disabled}
      typographyStyles={typographyStyles}
    >
      {children}
    </TextAction>
  </StyledButton>
);
